import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BrowserEventsService {

  constructor() {
    this.preventPinchZoom();
    this.preventContextMenu();
  }

  private preventPinchZoom(): void {
    // touchmove is the standardized cross-browser way (gesture* events are Safari-proprietary)
    document.addEventListener('touchmove', (e: TouchEvent) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    }, { passive: false });

    // Prevent trackpad/mouse-wheel pinch zoom on desktop (macOS especially)
    document.addEventListener('wheel', (e: WheelEvent) => {
      if (e.ctrlKey) {
        e.preventDefault();
      }
    }, { passive: false });
  }

  private preventContextMenu(): void {
    globalThis.oncontextmenu = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (target.nodeName && target.nodeName !== 'INPUT') {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
      return null;
    };
  }
}
